// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"1da327a9","1592":"845b4eb6","2057":"3b474a67","2444":"ebb053e3","4593":"310d8d8e","6474":"ca40a782","7002":"1da327a9","8412":"5ec507fc","9416":"1da327a9"}[chunkId] + ".chunk.css";
};